export default function (state) {
    let form = state;
    let data = {};

    switch (form.dateType) {
        case 1:
            if (form.dates[0]) data.IssueDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.IssueDateTo = {Serialized: form.dates[1]};
            break;
        case 2:
            if (form.dates[0]) data.StartDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.StartDateTo = {Serialized: form.dates[1]};
            break;
        case 3:
            if (form.dates[0]) data.EndDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.EndDateTo = {Serialized: form.dates[1]};
            break;
    }
    if (form.CurrencyIds.length) data.CurrencyIds = form.CurrencyIds;

    if (form.ContragentId) {
        switch (form.ContragentSearchTypeId){
            case 1:
                data.ClientId = form.ContragentId;
                break;
            case 2:
                data.PartnerId = form.ContragentId;
                break;
            case 3:
                data.PartnerLegalId = form.ContragentId;
                break;
        }
    }
    if (form.SumFrom) data.SumFrom = form.SumFrom;
    if (form.SumTo) data.SumTo = form.SumTo;
    if (form.AvailableSumFrom) data.AvailableSumFrom = form.AvailableSumFrom;
    if (form.AvailableSumTo) data.AvailableSumTo = form.AvailableSumTo;
    if (form.IsUsed) data.IsUsed = form.IsUsed;
    if (form.IsPayed) data.IsPayed = form.IsPayed;
    if (form.Type) data.Type = form.Type;
    if (form.OwnerLegalEntityId) data.OwnerLegalEntityId = form.OwnerLegalEntityId;
    return data;
}